// // import React, { useState } from 'react';
// // import './EventRegistrationForm.css';

// // const EventRegistrationForm = () => {
// //   const [formData, setFormData] = useState({
// //     email: '',
// //     phoneCountryCode: '+91',
// //     phoneNumber: '',
// //     name: '',
// //     graduationYear: '',
// //     company: '',
// //     jobTitle: '',
// //     otherPosition: '',
// //     whatsappConsent: true
// //   });

// //   const [showOtpField, setShowOtpField] = useState(false);
// //   const [registrationCount] = useState(282); // This could come from props or API

// //   const handleChange = (e) => {
// //     const { name, value, type, checked } = e.target;
// //     setFormData(prev => ({
// //       ...prev,
// //       [name]: type === 'checkbox' ? checked : value
// //     }));
// //   };

// //   const handleSubmit = (e) => {
// //     e.preventDefault();
// //     // Here you would typically send the data to your backend
// //     console.log('Form submitted:', formData);
    
// //     // Show OTP field after submission
// //     setShowOtpField(true);
// //   };

// //   const handleVerify = () => {
// //     // OTP verification logic
// //     console.log('Verifying OTP...');
// //   };

// //   const handleSendOtp = () => {
// //     // Resend OTP logic
// //     console.log('Resending OTP...');
// //   };

// //   return (
// //     <div className="floating-container marketing-form">
// //       <div className="scaler-event__register-heading-wrap">
// //         <div className="scaler-event__register-heading">Register NOW!</div>
// //         <div className="scaler-event__registration-count">
// //           <span className="bold">{registrationCount}</span> people registered
// //         </div>
// //       </div>

// //       <div className="floating-container__inner-wrap">
// //         <form onSubmit={handleSubmit} className="scaler-event__form">
// //           <a className="link bold auth-trigger">
// //             Already have an account? Click here
// //           </a>

// //           <div className="general-form">
// //             {/* Email */}
// //             <div className="form-field">
// //               <input
// //                 type="email"
// //                 name="email"
// //                 value={formData.email}
// //                 onChange={handleChange}
// //                 required
// //                 className="form-input"
// //               />
// //               <label className="mk-form-label">Email</label>
// //             </div>

// //             {/* Phone Number */}
// //             <div className="form-field">
// //               <div className="scaler-event__phone-field-wrap">
// //                 <div className="ib-phone-input">
// //                   <select
// //                     name="phoneCountryCode"
// //                     value={formData.phoneCountryCode}
// //                     onChange={handleChange}
// //                     className="ib-phone-input-country"
// //                   >
// //                     <option value="+91">+91 (India)</option>
// //                     <option value="+1">+1 (USA)</option>
// //                     {/* Add more country codes as needed */}
// //                   </select>
// //                   <input
// //                     type="tel"
// //                     name="phoneNumber"
// //                     value={formData.phoneNumber}
// //                     onChange={handleChange}
// //                     required
// //                     className="ib-phone-input-number form-input"
// //                     placeholder="Phone Number"
// //                   />
// //                 </div>
// //               </div>
// //               <label className="mk-form-label">Phone</label>
// //             </div>

// //             {/* Name */}
// //             <div className="form-field">
// //               <input
// //                 type="text"
// //                 name="name"
// //                 value={formData.name}
// //                 onChange={handleChange}
// //                 required
// //                 className="form-input"
// //               />
// //               <label className="mk-form-label">Name</label>
// //             </div>

// //             {/* Graduation Year (hidden by default) */}
// //             <div className="form-field hidden-org-year">
// //               <select
// //                 name="graduationYear"
// //                 value={formData.graduationYear}
// //                 onChange={handleChange}
// //                 className="form-input"
// //               >
// //                 <option value="">Select Graduation Year</option>
// //                 {Array.from({length: 30}, (_, i) => new Date().getFullYear() + i).map(year => (
// //                   <option key={year} value={year}>{year}</option>
// //                 ))}
// //               </select>
// //               <label className="mk-form-label">Graduation Year</label>
// //             </div>

// //             {/* Company (hidden by default) */}
// //             <div className="form-field hidden-org-name">
// //               <input
// //                 type="text"
// //                 name="company"
// //                 value={formData.company}
// //                 onChange={handleChange}
// //                 className="form-input"
// //                 placeholder="Company Name"
// //               />
// //               <label className="mk-form-label">Company</label>
// //             </div>

// //             {/* Job Title (hidden by default) */}
// //             <div className="form-field hidden-position">
// //               <select
// //                 name="jobTitle"
// //                 value={formData.jobTitle}
// //                 onChange={handleChange}
// //                 className="form-input"
// //               >
// //                 <option value="">Select Job Title</option>
// //                 <option value="Software Engineer">Software Engineer</option>
// //                 <option value="Product Manager">Product Manager</option>
// //                 <option value="Data Scientist">Data Scientist</option>
// //                 <option value="Other">Other</option>
// //               </select>
// //               <label className="mk-form-label">Job Title</label>
// //             </div>

// //             {/* Other Position (conditionally shown) */}
// //             {formData.jobTitle === 'Other' && (
// //               <div className="form-field">
// //                 <input
// //                   type="text"
// //                   name="otherPosition"
// //                   value={formData.otherPosition}
// //                   onChange={handleChange}
// //                   className="form-input"
// //                   placeholder="Please specify"
// //                 />
// //                 <label className="mk-form-label">Other Position</label>
// //               </div>
// //             )}

// //             {/* WhatsApp Consent */}
// //             <div className="form-field consent-checkbox">
// //               <label>
// //                 <input
// //                   type="checkbox"
// //                   name="whatsappConsent"
// //                   checked={formData.whatsappConsent}
// //                   onChange={handleChange}
// //                 />
// //                 I wish to receive further updates and confirmation via WhatsApp
// //               </label>
// //             </div>

// //             {/* OTP Field (shown after initial submission) */}
// //             {showOtpField && (
// //               <div className="form-field">
// //                 <input
// //                   type="text"
// //                   name="otp"
// //                   placeholder="Enter OTP"
// //                   className="form-input"
// //                 />
// //                 <div className="scaler-event__otp-actions-wrap">
// //                   Did not receive OTP?
// //                   <div className="scaler-event__otp-extra-actions">
// //                     <button type="button" onClick={handleSendOtp} className="link">
// //                       Resend OTP via Msg
// //                     </button>
// //                   </div>
// //                 </div>
// //               </div>
// //             )}

// //             {/* Submit/Verify Buttons */}
// //             <div className="scaler-event__submit-btn-wrap">
// //               {!showOtpField ? (
// //                 <button type="submit" className="sr-button secondary">
// //                   Register for free
// //                 </button>
// //               ) : (
// //                 <button type="button" onClick={handleVerify} className="sr-button secondary">
// //                   Verify
// //                 </button>
// //               )}

// //               {/* Terms and conditions */}
// //               <div className="ib-helper-text hint scaler-event__terms-wrapper">
// //                 By continuing, you agree to our Terms and Privacy Policy
// //               </div>
// //             </div>
// //           </div>
// //         </form>
// //       </div>
// //     </div>
// //   );
// // };

// // export default EventRegistrationForm;

// import React, { useState } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCalendarAlt, faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';
// import './EventRegistrationForm.css'; // Ensure you have the appropriate CSS for styling

// const FloatingEventRegistration = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     event: 'salesforce-bootcamp'
//   });
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const toggleForm = () => setIsOpen(!isOpen);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Here you would typically send the data to your backend
//     console.log('Form submitted:', formData);
//     setIsSubmitted(true);
//     setTimeout(() => {
//       setIsOpen(false);
//       setIsSubmitted(false);
//     }, 3000);
//   };

//   return (
//     <>
//       {/* Floating Button */}
//       <div 
//         className={`floating-button ${isOpen ? 'active' : ''}`}
//         onClick={toggleForm}
//       >
//         <FontAwesomeIcon icon={isOpen ? faTimes : faCalendarAlt} />
//         <span>{isOpen ? 'Close' : 'Register Now'}</span>
//       </div>

//       {/* Registration Form */}
//       {isOpen && (
//         <div className="floating-registration-form">
//           {isSubmitted ? (
//             <div className="success-message">
//               <FontAwesomeIcon icon={faCheck} className="success-icon" />
//               <h3>Registration Successful!</h3>
//               <p>We've sent confirmation details to your email.</p>
//             </div>
//           ) : (
//             <>
//               <h3>Register for Upcoming Event</h3>
//               <form onSubmit={handleSubmit}>
//                 <div className="form-group">
//                   <label htmlFor="name">Full Name</label>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label htmlFor="email">Email</label>
//                   <input
//                     type="email"
//                     id="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label htmlFor="phone">Phone Number</label>
//                   <input
//                     type="tel"
//                     id="phone"
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label htmlFor="event">Select Event</label>
//                   <select
//                     id="event"
//                     name="event"
//                     value={formData.event}
//                     onChange={handleChange}
//                     required
//                   >
//                     <option value="salesforce-bootcamp">Salesforce Bootcamp (June 25-30)</option>
//                     <option value="lwc-masterclass">LWC Masterclass (July 5-7)</option>
//                     <option value="admin-certification">Admin Certification Prep (July 15-20)</option>
//                   </select>
//                 </div>
                
//                 <button type="submit" className="submit-btn">
//                   Register Now
//                 </button>
//               </form>
//             </>
//           )}
//         </div>
//       )}
//     </>
//   );
// };

// export default FloatingEventRegistration;

// import React, { useState, useRef } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTimes } from '@fortawesome/free-solid-svg-icons';
// import './EventRegistrationForm.css'; // You'll need to create this CSS file

// const EventRegistration = () => {
//   const formRef = useRef(null);
//   const [submitted, setSubmitted] = useState(false);
//   const [isOpen, setIsOpen] = useState(true);

//   const handleSubmit = (e) => {
//     e.preventDefault();
    
//     if (!formRef.current) return;

//     // Get form values
//     const formData = new FormData(formRef.current);
//     const fullName = formData.get('fullName') || '';
    
//     // Split full name into first and last names
//     const [firstName, ...lastNameParts] = fullName.trim().split(' ');
//     const lastName = lastNameParts.join(' ');

//     // Create hidden inputs for Salesforce
//     const hiddenFields = [
//       { name: 'oid', value: '00DgK000002SOUb' },
//       { name: 'retURL', value: 'http://www.codexlnc.com' },
//       { name: 'salutation', value: 'Mr.' }, // Fixed salutation
//       { name: 'first_name', value: firstName },
//       { name: 'last_name', value: lastName },
//       { name: 'company', value: 'Code XLNC' }, // Fixed company
//       { name: '00NgK00000y9gYY', value: 'Event Registered' } // Fixed question
//     ];

//     // Create a temporary form for submission
//     const tempForm = document.createElement('form');
//     tempForm.action = 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DgK000002SOUb';
//     tempForm.method = 'POST';
//     tempForm.style.display = 'none';

//     // Add hidden fields to temp form
//     hiddenFields.forEach(field => {
//       const input = document.createElement('input');
//       input.type = 'hidden';
//       input.name = field.name;
//       input.value = field.value;
//       tempForm.appendChild(input);
//     });

//     // Add visible fields
//     ['phone', 'email'].forEach(fieldName => {
//       const value = formData.get(fieldName);
//       if (value) {
//         const input = document.createElement('input');
//         input.type = 'hidden';
//         input.name = fieldName;
//         input.value = value;
//         tempForm.appendChild(input);
//       }
//     });

//     // Submit the form
//     document.body.appendChild(tempForm);
//     tempForm.submit();
//     document.body.removeChild(tempForm);

//     setSubmitted(true);
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="event-registration-floating">
//       <button className="close-button" onClick={() => setIsOpen(false)}>
//         <FontAwesomeIcon icon={faTimes} />
//       </button>
      
//       {submitted ? (
//         <div className="success-message">
//           <h3>Thank You!</h3>
//           <p>Your event registration has been submitted successfully.</p>
//         </div>
//       ) : (
//         <form ref={formRef} onSubmit={handleSubmit} className="event-registration-form">
//           <h3>Event Registration</h3>
          
//           <div className="form-group">
//             <label htmlFor="fullName">Full Name*</label>
//             <input 
//               type="text" 
//               id="fullName" 
//               name="fullName" 
//               required 
//               placeholder="Enter your full name"
//             />
//           </div>
          
//           <div className="form-group">
//             <label htmlFor="email">Email*</label>
//             <input 
//               type="email" 
//               id="email" 
//               name="email" 
//               required 
//               placeholder="Enter your email"
//             />
//           </div>
          
//           <div className="form-group">
//             <label htmlFor="phone">Phone*</label>
//             <input 
//               type="tel" 
//               id="phone" 
//               name="phone" 
//               required 
//               placeholder="Enter your phone number"
//             />
//           </div>
          
//           <button type="submit" className="submit-button">
//             Register for Event
//           </button>
//         </form>
//       )}
//     </div>
//   );
// };

// export default EventRegistration;


// import React, { useState, useRef } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCalendarAlt, faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';
// import './EventRegistrationForm.css';

// const FloatingEventRegistration = () => {
//   const [isOpen, setIsOpen] = useState(true);
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const formRef = useRef(null);

//   const [formData, setFormData] = useState({
//     fullName: '',
//     email: '',
//     phone: '',
//     event: 'salesforce-bootcamp'
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
    
//     if (!formRef.current) return;

//     // Split full name into first and last
//     const [firstName, ...lastNameParts] = formData.fullName.trim().split(' ');
//     const lastName = lastNameParts.join(' ');

//     // Create hidden form for Salesforce submission
//     const hiddenForm = document.createElement('form');
//     hiddenForm.action = 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DgK000002SOUb';
//     hiddenForm.method = 'POST';
//     hiddenForm.style.display = 'none';

//     // Add required Salesforce fields
//     const addHiddenField = (name, value) => {
//       const input = document.createElement('input');
//       input.type = 'hidden';
//       input.name = name;
//       input.value = value;
//       hiddenForm.appendChild(input);
//     };

//     // Standard fields
//     addHiddenField('oid', '00DgK000002SOUb');
//     addHiddenField('retURL', 'http://www.codexlnc.com');
//     addHiddenField('salutation', 'Mr.'); // Fixed salutation
//     addHiddenField('first_name', firstName);
//     addHiddenField('last_name', lastName);
//     addHiddenField('email', formData.email);
//     addHiddenField('phone', formData.phone);
//     addHiddenField('company', 'Code XLNC'); // Fixed company
    
//     // Custom fields for event registration
//     addHiddenField('00NgK00000y9gYY', `Event Registration: ${formData.event}`); // Question field
    
//     // Submit the form
//     document.body.appendChild(hiddenForm);
//     hiddenForm.submit();
//     document.body.removeChild(hiddenForm);

//     setIsSubmitted(true);
//     setTimeout(() => {
//       setIsOpen(false);
//       setIsSubmitted(false);
//       setFormData({
//         fullName: '',
//         email: '',
//         phone: '',
//         event: 'salesforce-bootcamp'
//       });
//     }, 3000);
//   };

//   if (!isOpen) return null;

//   return (
//     <div className={`floating-registration-container ${isOpen ? 'open' : ''}`}>
//       <div className="floating-registration-form">
//         <button className="close-button" onClick={() => setIsOpen(false)}>
//           <FontAwesomeIcon icon={faTimes} />
//         </button>

//         {isSubmitted ? (
//           <div className="success-message">
//             <FontAwesomeIcon icon={faCheck} className="success-icon" />
//             <h3>Registration Successful!</h3>
//             <p>We'll contact you with event details.</p>
//           </div>
//         ) : (
//           <>
//             <h3>
//               <FontAwesomeIcon icon={faCalendarAlt} />
//               Event Registration
//             </h3>
//             <form ref={formRef} onSubmit={handleSubmit}>
//               <div className="form-group">
//                 <label htmlFor="fullName">Full Name*</label>
//                 <input
//                   type="text"
//                   id="fullName"
//                   name="fullName"
//                   value={formData.fullName}
//                   onChange={handleChange}
//                   required
//                   placeholder="First and Last Name"
//                 />
//               </div>
              
//               <div className="form-group">
//                 <label htmlFor="email">Email*</label>
//                 <input
//                   type="email"
//                   id="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   required
//                   placeholder="your@email.com"
//                 />
//               </div>
              
//               <div className="form-group">
//                 <label htmlFor="phone">Phone*</label>
//                 <input
//                   type="tel"
//                   id="phone"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   required
//                   placeholder="Phone number"
//                 />
//               </div>
              
//               <div className="form-group">
//                 <label htmlFor="event">Select Event*</label>
//                 <select
//                   id="event"
//                   name="event"
//                   value={formData.event}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="salesforce-bootcamp">Salesforce Bootcamp</option>
//                   <option value="lwc-masterclass">LWC Masterclass</option>
//                   <option value="admin-certification">Admin Certification</option>
//                 </select>
//               </div>
              
//               <button type="submit" className="submit-btn">
//                 Register Now
//               </button>
//             </form>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default FloatingEventRegistration;

import React, { useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faTimes, faCheck, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import './EventRegistrationForm.css';

const FloatingEventRegistration = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const formRef = useRef(null);

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    event: 'salesforce-bootcamp'
  });

  const toggleForm = () => setIsOpen(!isOpen);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formRef.current) return;

    // Split full name into first and last
    const [firstName, ...lastNameParts] = formData.fullName.trim().split(' ');
    const lastName = lastNameParts.join(' ');

    // Create hidden form for Salesforce submission
    const hiddenForm = document.createElement('form');
    hiddenForm.action = 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DgK000002SOUb';
    hiddenForm.method = 'POST';
    hiddenForm.style.display = 'none';

    // Add required Salesforce fields
    const addHiddenField = (name, value) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      hiddenForm.appendChild(input);
    };

    // Standard fields
    addHiddenField('oid', '00DgK000002SOUb');
    addHiddenField('retURL', 'http://www.codexlnc.com');
    addHiddenField('salutation', 'Mr.'); // Fixed salutation
    addHiddenField('first_name', firstName);
    addHiddenField('last_name', lastName);
    addHiddenField('email', formData.email);
    addHiddenField('phone', formData.phone);
    addHiddenField('company', 'Code XLNC'); // Fixed company
    
    // Custom fields for event registration
    addHiddenField('00NgK00000y9gYY', `Event Registration: ${formData.event}`);
    
    // Submit the form
    document.body.appendChild(hiddenForm);
    hiddenForm.submit();
    document.body.removeChild(hiddenForm);

    setIsSubmitted(true);
    setTimeout(() => {
      setIsOpen(false);
      setIsSubmitted(false);
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        event: 'salesforce-bootcamp'
      });
    }, 3000);
  };

  return (
    <div className="floating-registration-container">
      {/* Toggle Button at Bottom */}
      <div className="toggle-button" onClick={toggleForm}>
        <FontAwesomeIcon icon={isOpen ? faChevronDown : faCalendarAlt} />
        <span>{isOpen ? 'Close Form' : 'Register for Event'}</span>
      </div>

      {/* Registration Form */}
      {isOpen && (
        <div className="floating-registration-form">
          {isSubmitted ? (
            <div className="success-message">
              <FontAwesomeIcon icon={faCheck} className="success-icon" />
              <h3>Registration Successful!</h3>
              <p>We'll contact you with event details.</p>
            </div>
          ) : (
            <>
              <h3>
                <FontAwesomeIcon icon={faCalendarAlt} />
                Event Registration
              </h3>
              <form ref={formRef} onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="fullName">Full Name*</label>
                  <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                    placeholder="First and Last Name"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">Email*</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your@email.com"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="phone">Phone*</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="Phone number"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="event">Select Event*</label>
                  <select
                    id="event"
                    name="event"
                    value={formData.event}
                    onChange={handleChange}
                    required
                  >
                    <option value="salesforce-bootcamp">Salesforce Bootcamp - 22nd June 5 PM</option>
                    <option value="lwc-masterclass">LWC Masterclass - 21st June 5PM </option>
                    <option value="admin-certification">Business Analyst - 21st June 7PM </option>
                    <option value="Salesforce Interview Preparation - masterclass">LWC Masterclass - 22nd June 10PAM to 1 PM</option>
÷                  </select>
                </div>
                
                <button type="submit" className="submit-btn">
                  Register Now
                </button>
              </form>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default FloatingEventRegistration;